<template>
  <v-row>
    <v-col
      cols="12"
      sm="2"
      md="2"
      lg="2"
    >
      <div>
        <div
          v-if="loading"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>
        <div
          v-if="texto"
          class="text-center"
        >
          <h4>{{ texto }}</h4><br>
        </div>
        <div>
          <div
            v-if="precoMedio.length > 0"
            id="idTable"
            style="overflow-x: auto; max-width: 100%;"
          >
            <table
              style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                  >
                    Preço praticado
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in precoMedio"
                  :key="item.id"
                >
                  <td
                    id="dadoMovimentacao"
                    style="text-align: center;"
                    :style="{ backgroundColor: textoFiltro === item.preco ? 'yellow' : '' }"
                    @click="enableDetalhe(item)"
                  >
                    {{ item.precoExibicao }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </v-col>
    <v-col
      cols="12"
      sm="10"
      md="10"
      lg="10"
    >
      <div>
        <div
          v-if="loading1"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="error"
          class="alert alert-danger"
        >
          {{ error1 }}
        </div>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
            lg="2"
          >
            <v-btn
              id="btnPrint"
              small
              dark
              :color="corPrimaria"
              :loading="imprimindo"
              @click="exportExcel()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Exporta Excel
              <template v-slot:loader>
                <span>Gerando...</span>
              </template>
            </v-btn>
          </v-col>
        </v-row>
        <br>
        <div
          v-if="precoMedio.length > 0"
          id="idTableDados"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('cliente')"
                >
                  Cliente
                  <span v-if="sortBy === 'cliente'">
                    <v-icon>
                      {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                    </v-icon>
                  </span>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('data')"
                >
                  Data
                  <span v-if="sortBy === 'data'">
                    <v-icon>
                      {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                    </v-icon>
                  </span>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('segmento')"
                >
                  Segmento
                  <span v-if="sortBy === 'segmento'">
                    <v-icon>
                      {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                    </v-icon>
                  </span>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('volume')"
                >
                  Volume
                  <span v-if="sortBy === 'volume'">
                    <v-icon>
                      {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                    </v-icon>
                  </span>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('media')"
                >
                  Média de Venda
                  <span v-if="sortBy === 'media'">
                    <v-icon>
                      {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                    </v-icon>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in (dadosTabelaAux.length > 0 ? dadosTabelaAux : dadosTabela)"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.cliente }}
                  <span
                    v-if="item.preco"
                  >
                    <b><i>{{ item.preco }}</i></b>
                  </span>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: center;"
                >
                  {{ item.data }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.segmento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.volumeExibicao }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.mediaExibicao }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import ControlePreco from '../../../../services/controlepreco'
  import eventEmit from '../../components/core/EventoEmit'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'DashboardPrecoPraticadoGeral',
    emits: ['setDadosPrecoPraticadoCidade3'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      title: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      areas: [],
      vendedores: [],
      produtos: [],
      linhas: [],
      volume: [],
      precoMedio: [],
      clientes: [],
      segmento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorExibicao: false,
      montarGrafico: true,
      loading: false,
      error: null,
      loading1: false,
      error1: null,
      headers: [
        { text: 'Cliente', value: 'cliente', width: '200px', align: 'left', class: 'black--text title' },
        { text: 'Data', value: 'data', width: '80px', align: 'left', class: 'black--text title' },
        { text: 'Segmento', value: 'segmento', width: '100px', align: 'left', class: 'black--text title' },
        { text: 'Volume', value: 'volume', width: '80px', align: 'right', class: 'black--text title' },
        { text: 'Média Venda', value: 'media', width: '80px', align: 'right', class: 'black--text title' },
      ],
      headersPrecoPraticado: [
        { text: 'Preço praticado', value: 'preco', align: 'center', class: 'black--text title' },
      ],
      dadosTabela: [],
      enableTabela: false,
      texto: false,
      textoFiltro: '',
      sortBy: '',
      sortDesc: false,
      dadosTabelaAux: [],
      enableBtn: true,
      corPrimaria: '#2863af',
      imprimindo: false,
    }),

    created () {
      eventEmit.$on('update-form-mais-vida-cidade3', this.handleUpdateDados)

      eventEmit.$on('enable-consultas', this.handleEnableDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida-cidade3', this.handleUpdateDados)

      eventEmit.$off('enable-consultas', this.handleEnableDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, select, produtoSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, segmento) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = select
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.segmento = segmento

        this.atualizaGrafico()
      },

      handleEnableDados () {
        this.dadosTabela = []
        this.enableTabela = false
        this.texto = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }
      },

      async atualizaGrafico () {
        this.loading = true
        this.dadosTabela = []
        this.dadosTabelaAux = []
        this.enableTabela = false
        this.texto = false
        this.precoMedio = []
        this.textoFiltro = ''

        await ControlePreco.showGraficoPrecoPraticadoCidade(this.dataInicial, this.dataFinal, this.empresaSelect, this.produtos, this.vendedores, this.redes, this.cidades, this.areas, localStorage.tokencontrato, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.precoMedio = resposta.data.dadosFaturamento.map((item) => {
              var lista = ({
                preco: item.preco,
                precoExibicao: item.preco.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                dadosDetalhe: this.dadosDetalhe(item.dadosDetalhe),
              })

              return lista
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            this.title = null

            this.texto = e.data.msg

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.texto = e.data.text

            this.title = null

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Não há dados com os filtos selecionados') {
            this.texto = e.data.text

            this.title = null

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      dadosDetalhe (value) {
        const dadosTabela = value.map((item) => {
          var listaTabela = ({
            codCliente: item.codCliente,
            cliente: item.cliente,
            data: item.ultimaCompra,
            volume: item.volume,
            volumeExibicao: item.volume.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            segmento: item.segmento,
            preco: item.preco,
            media: item.media,
            mediaExibicao: item.media.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          })

          return listaTabela
        })

        return dadosTabela
      },

      enableDetalhe (item) {
        try {
          this.loading1 = true

          this.textoFiltro = item.preco

          this.dadosTabela = []

          this.dadosTabelaAux = []

          this.enableTabela = false

          setTimeout(() => {
            this.dadosTabela = item.dadosDetalhe

            this.enableTabela = true

            eventEmit.$emit('set-dados-preco-praticado-cidade2', this.textoFiltro, this.dadosTabela)
          })
        } catch (error) {
          console.log(error)
        } finally {
          eventEmit.$emit('set-dados-preco-praticado-cidade3', this.textoFiltro, this.dadosTabela)
          this.loading1 = false
        }
      },

      mudarOrdenacao (campo) {
        if (this.sortBy === campo) {
          this.sortDesc = !this.sortDesc
        } else {
          this.sortBy = campo
          this.sortDesc = false
        }

        this.buscarDados()
      },

      buscarDados () {
        const novaOrdenacao = [...this.dadosTabela]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.sortBy] < b[this.sortBy]) result = -1

          if (a[this.sortBy] > b[this.sortBy]) result = 1

          if (this.sortDesc) result *= -1

          return result
        })

        this.dadosTabelaAux = novaOrdenacao

        eventEmit.$emit('set-dados-preco-praticado-cidade3', this.textoFiltro, novaOrdenacao)
      },

      async exportExcel () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Preço Praticado Cidade')

          let posY = 1

          const inserirTitulo = (worksheet) => {
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresaSelect.map(e => e.empresaSelect))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

            posY += 1

            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Produto Selecionado: ' + this.produtos.produto
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }
            posY += 2

            worksheet.getCell(`A${posY}`).value = 'Preço Praticado Selecionado ' + parseFloat(this.textoFiltro).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            worksheet.getCell(`A${posY}`).value = 'Cidade Selecionada ' + this.cidades.cidade
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2
          }

          posY += 1

          const ajustarLarguraColunas = (worksheet, headers, tableData) => {
            headers.forEach((header, i) => {
              let maxColumnWidth = header.length
              tableData.forEach(row => {
                const columnText = row[i] ? row[i].toString() : ''
                maxColumnWidth = Math.max(maxColumnWidth, columnText.length)
              })
              worksheet.getColumn(i + 1).width = maxColumnWidth + 2
            })
          }

          inserirTitulo(worksheet)

          posY += 2

          const tableHeaders = this.headers.map(header => header.text)

          const tableAux = this.dadosTabelaAux.length > 0 ? this.dadosTabelaAux : this.dadosTabela

          const tableData = tableAux.map(item => [
            item.cliente,
            item.data,
            item.segmento,
            item.volume,
            item.media,
          ])

          worksheet.addRow(tableHeaders).font = { bold: true }
          tableData.forEach(row => worksheet.addRow(row))
          posY += tableData.length + 1

          ajustarLarguraColunas(worksheet, tableHeaders, tableData)

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_preco_praticado_cidade.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindo = false
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #idTableDados {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  #idTableDados {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

  #myChartMaisVida5
    display: grid
    align-items: center
    font-weight: bold
    width: 500
    height: 330

  #textTable
    font-size: 0.75rem !important
</style>
